export default __webpack_public_path__ + "static/media/man_in_the_wind_5.ba6f8efe.png";